import { render } from "./OverXSection.vue?vue&type=template&id=6e3a5ec6&scoped=true"
import script from "./OverXSection.vue?vue&type=script&lang=js"
export * from "./OverXSection.vue?vue&type=script&lang=js"

import "./OverXSection.vue?vue&type=style&index=0&id=6e3a5ec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3a5ec6"]])

export default __exports__